// base
import React from 'react';
import { useHistory } from 'react-router';

// styles
import { StyledAuthorizedResult } from './style';

// routes
import { ROUTE_ROOT } from 'routes/const';

// libraries
import { Result, Button } from 'antd';

export const AuthorizedResult = () => {
  const history = useHistory();

  return (
    <StyledAuthorizedResult>
      <Result
        status="403"
        title="403 요청하신 페이지에 접근권한이 없습니다."
        subTitle={
          <div style={{ margin: '12px 0' }}>
            비정상적인 접근이거나 접근 권한이 없습니다.
            <br />
            정상적인 접근일 경우 관리자에게 문의 하시기 바랍니다.
          </div>
        }
        extra={
          <Button type="primary" onClick={() => history.push(ROUTE_ROOT)}>
            홈으로 돌아가기
          </Button>
        }
      />
    </StyledAuthorizedResult>
  );
};
